import styled from '@emotion/styled'

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  width: 300px;
  
  & > * {
    margin-top: 20px !important;
  }
`
